import {
  DEFAULT_LIMIT,
  fetchAllCursorPages,
  schedulingDelete,
  schedulingGet,
  schedulingPost,
  schedulingPut,
  versionBody,
} from "./client";

export function listAvailabilityExceptions({
  organizationRef,
  availabilityExceptionId,
  availabilityRuleId,
  localDate,
  active,
  cursor,
  limit = DEFAULT_LIMIT,
  signal,
  consistency,
}) {
  return schedulingGet("availability-exceptions", {
    organizationRef,
    availabilityExceptionId,
    availabilityRuleId,
    localDate,
    active,
    cursor,
    limit,
  }, { signal, consistency });
}

export async function listAllAvailabilityExceptions(params) {
  return fetchAllCursorPages({
    signal: params.signal,
    itemsKey: "availabilityExceptions",
    fetchPage: (cursor) => listAvailabilityExceptions({ ...params, cursor }),
  });
}

export function createAvailabilityException(body) {
  return schedulingPost("availability-exceptions", body);
}

export function updateAvailabilityException(body) {
  const { expectedVersion, ...rest } = body;
  return schedulingPut("availability-exceptions", {
    ...rest,
    ...versionBody(expectedVersion),
  });
}

export function deactivateAvailabilityException({
  organizationRef,
  availabilityExceptionId,
  expectedVersion,
}) {
  return schedulingDelete("availability-exceptions", {
    organizationRef,
    availabilityExceptionId,
    ...versionBody(expectedVersion),
  });
}
